import { useState } from 'react';
import { ReactComponent as ErrorIcon } from 'assets/images/errorIcon.svg';
import { Controller, useFormState } from 'react-hook-form';
import { Textarea, Wrapper } from './styles';
import { InputFormProps } from './types';

export function InputTextAreaForm({
  control,
  name,
  label,
  id,
  required,
  maxLength = undefined,
}: Readonly<InputFormProps>) {
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);
  const { errors } = useFormState({
    control,
  });

  const inputError = errors[name]?.message;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Wrapper>
          <Textarea
            invalid={!!inputError}
            onFocus={onFocus}
            onBlur={onBlur}
            focused={focused}
            hasValue={!!field.value}
          >
            <span className="textarea-label">
              {label}
              <span>{required ? '*' : ''}</span>
            </span>
            <textarea id={id} {...field} maxLength={maxLength} />
          </Textarea>
          {!!inputError && (
            <span className="textarea-error">
              <ErrorIcon />
              {String(inputError)}
            </span>
          )}
        </Wrapper>
      )}
    />
  );
}
